export const StateMode = {
  OPACITY: 'opacity',
  BACKGROUND: 'background',
  NONE: 'none',
} as const;

export type StateMode = Union<typeof StateMode>;
